/*scrollable sticky sidebar=filter in catalog*/
$(document).ready(function () {

    if ($('.senat-catalog-filter').length) {

        var $senatCatalog = $('.senat-catalog');
        var $body = $("body");

        function fixedFilter() {
            var $scrollTop = $(window).scrollTop();

            if ($scrollTop > $senatCatalog.offset().top) {
                $body.delay(800).addClass("fixed-filter");

                $('.senat-catalog-filter').stickySidebar({
                    containerSelector: '.senat-catalog',
                    innerWrapperSelector: '.senat-filter',
                    topSpacing: 60,
                    bottomSpacing: 60
                });
            } else {
                $body.delay(800).removeClass("fixed-filter");
            }
        }

        // Вызов функций при скролле страницы
        if ($(window).width() > 768) {
            $(window).scroll(function () {
                fixedFilter();
            });
        }

    }
});
